import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { DeviceService } from '../../../_services/device.service';
import { IconSizeEnum } from '../../../_enums/icon.enum';
import { IIconLink } from '../../../_interfaces/icon-link.interface';
import { PositionEnum } from '../../../_enums/position.enum';
import { SdLinkComponent } from '../../links/link/link.component';
import { SdListComponent } from '../../lists/list/list.component';
import { SdThemeComponent } from '../../abstract/theme/theme.component';
import { BrandsEnum } from '../../../_enums/brands.enum';

@Component({
  selector: 'sd-social-media',
  templateUrl: './social-media.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdListComponent,
    SdLinkComponent,
    TranslateModule
  ]
})
export class SdSocialMediaComponent extends SdThemeComponent implements OnInit, OnDestroy {
  @Input()
  data: IIconLink[];

  @Input()
  brand: BrandsEnum;

  mobileSubscription: Subscription;
  isMobile$: boolean;
  positionEnum = PositionEnum;
  iconSize = IconSizeEnum;

  constructor(
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService
  ) {
    super();
  }

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }
}
